<template>
  <v-main>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-main>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'EZBET88 - ' + this.$route.name
    }
  }
}
</script>

<style>
#core-view {
 margin-bottom: 50px;
}
</style>
